/**
 * lib/stripe.ts — Instância singleton do Stripe Server SDK
 */

import Stripe from "stripe";

if (!process.env.STRIPE_SECRET_KEY) {
  console.warn("[Stripe] STRIPE_SECRET_KEY not set. Stripe features will be disabled.");
}

export const stripe = process.env.STRIPE_SECRET_KEY
  ? new Stripe(process.env.STRIPE_SECRET_KEY, {
      apiVersion: "2025-06-30.basil",
      typescript: true,
    })
  : null;

// ── Planos de crédito ─────────────────────────────────────────────────────

export interface CreditPackage {
  id: string;
  name: string;
  credits: number;
  priceId: string;       // Stripe Price ID (configure no painel Stripe)
  priceCents: number;    // Valor em centavos (BRL)
  description: string;
  badge?: string;
  popular?: boolean;
}

export const CREDIT_PACKAGES: CreditPackage[] = [
  {
    id: "starter",
    name: "Starter",
    credits: 50,
    priceId: process.env.STRIPE_PRICE_STARTER ?? "",
    priceCents: 2990,   // R$ 29,90
    description: "Ideal para explorar e criar os primeiros projetos",
    badge: "Econômico",
  },
  {
    id: "pro",
    name: "Pro",
    credits: 200,
    priceId: process.env.STRIPE_PRICE_PRO ?? "",
    priceCents: 9990,   // R$ 99,90
    description: "Para criadores frequentes e prototipadores",
    badge: "Popular",
    popular: true,
  },
  {
    id: "studio",
    name: "Studio",
    credits: 500,
    priceId: process.env.STRIPE_PRICE_STUDIO ?? "",
    priceCents: 19990,  // R$ 199,90
    description: "Para bureaus, empresas e uso intensivo de API B2B",
    badge: "Melhor valor",
  },
];

export function formatBRL(cents: number): string {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(cents / 100);
}
